var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1250px",
    height: "601px",
    viewBox: "0 0 1250 601",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ra_logo",
    transform: "translate(0.000000, -1.000000)",
    fill: "#7F908F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(625.000000, 301.100000) scale(-1, 1) rotate(-180.000000) translate(-625.000000, -301.100000) translate(0.000000, 0.600000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,412.6 L0,224.6 L163.8,224.4 C348.3,224 330.7,224.8 349,216 L358.5,211.3 L454,116.2 C540.9,29.7 550.3,20.6 558.3,15.7 C568.5,9.4 580.8,4.5 593,1.9 C601.1,0.2 613,0.1 848.5,0.1 C1128,0.1 1102.2,-0.7 1120.3,8.3 L1129.5,12.9 L1185.8,69 C1239,122 1242.3,125.5 1245.8,132.5 C1249.4,139.8 1249.5,140.2 1249.5,151.6 C1249.5,163 1249.4,163.3 1245.6,171.2 C1241.8,179.1 1240.9,179.9 1063.6,357.4 C965.7,455.4 885.1,535.6 884.5,535.6 C883.2,535.6 778,430.4 778,429.1 C778,428.6 840.2,365.9 916.2,289.9 L1054.5,151.6 L854.4,151.6 C657.6,151.6 654.2,151.6 646.5,153.6 C636.9,156 630.2,159.1 621.8,164.6 C617.7,167.4 583.5,200.8 522,262.1 C443.3,340.5 427.3,356 421,359.9 C411.4,365.8 403.9,369.1 392.6,372.4 L383.5,375 L267.3,375.4 L151,375.7 L151,412.2 L151,448.7 L273.3,448.4 L395.5,448.1 L405.3,445.8 C430.4,440.2 450.6,431 470.2,416.4 C475.4,412.5 504.5,384.4 548.8,340.2 L619,270.1 L672,323.1 C701.2,352.3 725,376.6 725,377.1 C725,378.5 588.9,514.1 578.5,523.2 C524.8,569.8 460,595.8 388.1,599.6 C378.4,600.1 287.1,600.6 185.3,600.6 L0,600.6 L0,412.6 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaLogo);
export default __webpack_public_path__ + "static/media/ra_logo.63c4c2afaa0aaafb4d2752e99e5cad35.svg";
export { ForwardRef as ReactComponent };